import script from "./SectionBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionBlock.vue?vue&type=script&setup=true&lang=js"

import "./SectionBlock.vue?vue&type=style&index=0&id=55eecfe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55eecfe6"]])

export default __exports__